import { Card, CommandButton } from "components"
import { useToggle } from "utils"

type CommandButtonsProps = {
  showSaveButton?: boolean
  showDeleteButton?: boolean
  onDelete?: () => void
  onSave?: () => void
}

export const CommandButtons = ({
  showSaveButton,
  showDeleteButton,
  onDelete,
  onSave
}: CommandButtonsProps) => {
  const modalJournalInvoice = useToggle(false)

  return (
    <>
      <Card>
        <Card.Body className="flex flex-col gap-5">
          <section className="flex flex-wrap justify-between gap-3">
            <section className="flex flex-wrap gap-3">
              <CommandButton actiontype="help" />
              <CommandButton actiontype="print" />
              <CommandButton actiontype="email" />
              <CommandButton actiontype="journal" onClick={modalJournalInvoice.toggle} />
              <CommandButton actiontype="attachment" />
            </section>

            <section className="flex flex-wrap gap-3">
              {showDeleteButton && (
                <CommandButton actiontype="delete" onClick={onDelete} />
              )}

              {showSaveButton && (
                <CommandButton
                  actiontype="save"
                  type="button"
                  color="primary"
                  permission="ST121"
                  onClick={onSave}
                />
              )}
            </section>
          </section>
        </Card.Body>
      </Card>
    </>
  )
}
